import DataSource from './DataSource';


const indicator = {
 "demo": "Demographic",
 "demo-1": "Adolescents Ages 10-19 (number)",
 "demo-1-tab": "num10-19",
 "demo-1-i": "Number of adolescents ages 10-19",
 "demo-1-source": "source-1",
 "demo-2": "Adolescents Ages 10-19 (%)",
 "demo-2-tab": "perct10-19",
 "demo-2-i": "Percent of adolescents ages 10-19",
 "demo-2-source": "source-1",
 "demo-3": "NCD Deaths (age-standardized rate)",
 "demo-3-tab": "n_c_drate",
 "demo-3-i": "Age-standardized death rate for all NCDs (per 100,000)",
 "demo-3-source": "source-2",
 "demo-4": "NCD Deaths (% of all deaths)",
 "demo-4-tab": "%25n_c_ddeaths",
 "demo-4-i": "Percent of total deaths due to NCDs",
 "demo-4-source": "source-3",
 "demo-5": "Premature NCD Deaths (probability of (%))",
 "demo-5-tab": "premdeaths",
 "demo-5-i": "Probability (%) of dying between age 30 and exact age 70 from cardiovascular disease, cancer, diabetes, or chronic respiratory disease.",
 "demo-5-source": "source-4",

 "sedentary": "Physical Inactivity",
 "sedentary-1": "Physically Inactive (%)",
 "sedentary-1-tab": "notactive",
 "sedentary-1-i": "Percent of youth who were NOT physically active for 60 minutes or more on at least 5 (or 7) days in the past week. Data from HBSC are specific to moderate-to-vigorous-intensity physical activity of at least 60 minutes daily.",
 "sedentary-1-source": "source-6&&source-8",
 "sedentary-2": "Physically Inactive, vigorous activity (%)",
 "sedentary-2-tab": "notvigact",
 "sedentary-2-i": "Percent of youth who did NOT participate in vigorous-intensity physical activity 4 or more times per week (HBSC only)",
 "sedentary-2-source": "source-8",
 "sedentary-3": "Sedentary, 3+ hours daily (%)",
 "sedentary-3-tab": "sed3hrs",
 "sedentary-3-i": "Percent of youth who spent 3 or more hours per day sitting and watching television, playing computer games, or talking with friends, when not in school or doing homework during a typical or usual day",
 "sedentary-3-source": "source-6",
 "sedentary-4": "Watching TV, 2+ hours daily (%)",
 "sedentary-4-tab": "t_v2hr%2B",
 "sedentary-4-i": "Percent of youth who spent 2 or more hours watching television on weekdays (HBSC only)",
 "sedentary-4-source": "source-8",
 "sedentary-5": "Using Computer, 2+ hours daily (%)",
 "sedentary-5-tab": "comp2hr%2B",
 "sedentary-5-i": "Percent of youth who spent 2 or more hours on a computer on weekdays (HBSC only)",
 "sedentary-5-source": "source-8",
 // "sedentary-6": "3+ hours/day sitting and watching TV, playing computer games, or talking with friends, when not in school or doing homework during a typical or usual day",
 // "sedentary-6-tab": "sed3hrs",

 "diet": "Unhealthy Diet",
 "diet-1": "Soda Drinkers, daily (%)",
 "diet-1-tab": "dlysoda",
 "diet-1-i": "Percent of youth who usually drank carbonated soft drinks one or more times per day in the past 30 days",
 "diet-1-source": "source-6&&source-7&&source-8",
 "diet-2": "Fruit Consumers, daily (%)",
 "diet-2-tab": "dlyfruit",
 "diet-2-i": "Percent of youth who consume fruit daily (HBSC only)",
 "diet-2-source": "source-7&&source-8",
 "diet-3": "Vegetable Consumers, daily (%)",
 "diet-3-tab": "dlyveg",
 "diet-3-i": "Percent of youth who consume vegetable daily (HBSC only)",
 "diet-3-source": "source-8",

 //"diet-4": "Daily Soda Consumption (HBSC) [Drink soda 1+ times/day during the 30 days before the survey (GSHS)]",
 //"diet-4-tab": "dlysoda",

 "tobacco": "Tobacco Use",
 "tobacco-1": "Any Tobacco Users, current (%)",
 "tobacco-1-tab": "tobusers",
 "tobacco-1-i": "Percent of youth who used any tobacco on at least 1 day in the past 30 days",
 "tobacco-1-source": "source-5&&source-6",
 "tobacco-2": "Smoked Tobacco Users, current (%)",
 "tobacco-2-tab": "smokers",
 "tobacco-2-i": "Percentage of youth who smoked tobacco on at least 1 day in the past 30 days",
 "tobacco-2-source": "source-5",
 "tobacco-3": "Cigarette Smokers, current (%)",
 "tobacco-3-tab": "ciguser",
 "tobacco-3-i": "Percent of youth who smoked cigarettes on at least 1 day in the past 30 days",
 "tobacco-3-source": "source-5&&source-6",
 "tobacco-4": "Cigarette Smokers, frequent  (%)",
 "tobacco-4-tab": "freqcig",
 "tobacco-4-i": "Percent of youth who smoked cigarettes on 20 or more days in the past 30 days",
 "tobacco-4-source": "source-5",
 "tobacco-5": "Cigarette Smokers, weekly (%)",
 "tobacco-5-tab": "tobacco_1wk",
 "tobacco-5-i": "Percent of youth who smoked cigarettes on at least 1 day in the past 7 days (HBSC only)",
 "tobacco-5-source": "source-7",
 "tobacco-6": "Smoked Tobacco Users, current, non-cigarette (%)",
 "tobacco-6-tab": "othsmk",
 "tobacco-6-i": "Percent of youth who used smoked tobacco products other than cigarettes, such as cigars, water pipes, and bidis, on at least 1 day in the past 30 days",
 "tobacco-6-source": "source-5",
 "tobacco-7": "Smokeless Tobacco Users, current (%)",
 "tobacco-7-tab": "smkless",
 "tobacco-7-i": "Percent of youth who used smokeless tobacco products, such as chewing tobacco and snuff, on at least 1 day in the past 30 days",
 "tobacco-7-source": "source-5",
 "tobacco-8": "Any Tobacco Users, current, non-cigarette (%)",
 "tobacco-8-tab": "othuser",
 "tobacco-8-i": "Percent of youth who used tobacco products other than cigarettes on at least 1 day in the past 30 days",
 "tobacco-8-source": "source-5",
 "tobacco-9": "15 Year-olds with First Cigarette Use by Age 14 (%)",
 "tobacco-9-tab": "1stsmoke",
 "tobacco-9-i": "Percent of 15 Year-olds who first smoked cigarettes before age 14 (HBSC only)",
 "tobacco-9-source": "source-7",

 "alcohol": "Alcohol Use",
 "alcohol-1": "Alcohol Users, current (%)",
 "alcohol-1-tab": "alcuser",
 "alcohol-1-i": "Percent of youth who had at least one drink of alcohol on at least one day in the past 30 days",
 "alcohol-1-source": "source-6",
 "alcohol-2": "Alcohol Users, weekly (%)",
 "alcohol-2-tab": "alc1wk",
 "alcohol-2-i": "Percent of youth who had at least one drink of alcohol on at least 1 day in the past 7 days (HBSC only)",
 "alcohol-2-source": "source-7",
 "alcohol-3": "Drunkenness 1+ Times (%)",
 "alcohol-3-tab": "drunk",
 "alcohol-3-i": "Percent of youth who ever drank so much alcohol that they were very drunk one or more times during their life",
 "alcohol-3-source": "source-6",
 "alcohol-4": "Drunkenness 2+ Times (%)",
 "alcohol-4-tab": "drunk2%2B",
 "alcohol-4-i": "Percent of youth who ever drunk so much alcohol that they were very drunk on two or more occasions (HBSC only)",
 "alcohol-4-source": "source-7",
 "alcohol-5": "Ever-Drinkers with First Alcohol Use by Age 14 (%)",
 "alcohol-5-tab": "alc14",
 "alcohol-5-i": "Percent of youth who drank alcohol before age 14,  among youth who ever had a drink other than a few sips",
 "alcohol-5-source": "source-6",
 "alcohol-6": "15 Year-olds with First Alcohol Use by Age 14 (%)",
 "alcohol-6-tab": "1stdrunk13",
 "alcohol-6-i": "Percent of 15 Year-olds who first drank alcohol before age 14 (HBSC only)",
 "alcohol-6-source": "source-7",

 "overweight": "Obese/Overweight",
 "overweight-1": "Obese (%)",
 "overweight-1-tab": "obese",
 "overweight-1-i": "Percent of youth who are obese (>+2SD from median for BMI by age and sex)",
 "overweight-1-source": "source-6&&source-8",
 "overweight-2": "Overweight or Obese (%)",
 "overweight-2-tab": "owobese",
 "overweight-2-i": "Percent of youth who are overweight or obese (>+1SD from median for BMI by age and sex)",
 "overweight-2-source": "source-6",
 // "overweight-3": "Overweight or Obese (measure 1)",
 // "overweight-3-tab": "owobese",
 // "overweight-4": "Overweight or Obese (measure 2)",
 // "overweight-4-tab": "",

 "mental": "Mental Health",
 "mental-1": "Suicidal Thoughts (%)",
 "mental-1-tab": "consuicide",
 "mental-1-i": "Percent of youth who ever seriously considered attempting suicide during the past 12 months",
 "mental-1-source": "source-6",
 "mental-2": "Suicidal Attempts (%)",
 "mental-2-tab": "attsuicide",
 "mental-2-i": "Percent of youth who actually attempted suicide one or more times during the past 12 months",
 "mental-2-source": "source-6",
 "mental-3": "Lacking Close Friends (%)",
 "mental-3-tab": "nofriends",
 "mental-3-i": "Percent of youth who had no close friends",
 "mental-3-source": "source-6",
 "mental-4": "Feeling Low, 1+ per week (%)",
 "mental-4-tab": "feltlow_1wk",
 "mental-4-i": "Percent of youth who felt low more than once a week (HBSC only)",
 "mental-4-source": "source-7",

}

export default indicator



// WEBPACK FOOTER //
// ./src/data/IndicatorValueMap.js